<template>
  <div class="image-video-wrapper">
    <ica-youtube-video
      v-if="videoUrl"
      :alt="alt"
      :url="videoUrl"
    />
    <epi-picture
      v-else-if="image"
      v-edit="'Image'"
      :image="image"
      :use-picture="usePicture"
      :auto-quality="autoQuality"
      :sizes="dimensions"
      :auto-aspect-ratio="autoAspectRatio"
      :class="{'margin-bottom': caption}"
    />
    <p
      v-if="caption"
      v-edit="'Caption'"
      class="image-video-wrapper__caption"
      v-text="caption"
    />
  </div>
</template>

<script>
import IcaYoutubeVideo from '~/@ica/ica-molecules-vue/dist/YoutubeVideo'

export default {
  name: "ImageVideoComponent",
  components: {
    IcaYoutubeVideo
  },
  props: {
    alt: {
      type: String,
      default: 'Film från youtube, saknar beskrivning'
    },
    caption: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => ({})
    },
    videoUrl: {
      type: String,
      default: ""
    },
    dimensions: {
      type: Object,
      default: () => ({
        small: {
          width: 734
        },
        medium: {
          width: 799
        },
        large: {
          width: 821
        }
      })
    },
    usePicture: {
      type: Boolean,
      default: false,
    },
    autoAspectRatio: {
      type: Boolean,
      default: false,
    },
    autoQuality: {
      type: String,
      default: "auto"
    },
  },
}
</script>

<style lang="scss">
.image-video-wrapper {
  margin-bottom: 2.5rem;

  @include media-breakpoint-up(md) {
    padding: 0 3rem;
  }

  @include media-breakpoint-up(lg) {
    padding: 0 3.5rem;
  }

  @include media-breakpoint-up(xl) {
    padding: 0 5rem;
  }

  & .epi-picture {
    picture,
    img {
      border-radius: 0.25rem;
      margin: 0;
      padding: 0;
      width: 100%;
    }
  }

  &__caption {
    margin: 0;
    color: $color-grey-mid;

    @include font(text, 1, "normal");
  }
}

.margin-bottom {
  margin-bottom: 0.5rem;
}

</style>
